// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__13qe6","active_link":"Navigation_active_link__LPw59","nav":"Navigation_nav__7WdPp"};